import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon, ZapIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, popupSales } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const cycle = (i: number) => {
      timeout = setTimeout(() => {
        setIndex(i % popupSales.length);
        setVisible(true);
        timeout = setTimeout(() => {
          setVisible(false);
          cycle(i + 1);
        }, 5200);
      }, 3200);
    };
    cycle(0);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const sale = popupSales[index];
  const y = reduceMotion ? 0 : 14;
  return <AnimatePresence data-id="element-136" data-mp="18r44z91zhp8r">
      {visible && !dismissed ? <motion.aside initial={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2 left-2 z-50 w-[14.5rem] overflow-hidden rounded-lg border-2 border-volt bg-carbon shadow-xl shadow-volt/30 ring-2 ring-white/70 sm:w-[17rem]" aria-live="polite" data-id="element-137" data-mp="1zruy7t97ycp6">
          <div className="flex items-center gap-1.5 bg-volt px-2 py-1" data-id="element-138" data-mp="2ngxb6nswrhdc">
            <ZapIcon className="h-3.5 w-3.5 fill-carbon text-carbon" aria-hidden="true" data-id="element-139" data-mp="2nja2vsogx63l" />
            <p className="text-[0.56rem] font-black uppercase tracking-[0.14em] text-carbon" data-id="element-140" data-mp="2sh1rodttgc3k">
              New purchase verified
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="ml-auto text-carbon/70 transition-colors duration-150 ease-out hover:text-carbon" data-id="element-141" data-mp="y2shi5hskrue">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-142" data-mp="v2h9nq63xw2c" />
            </button>
          </div>
          <a href={PURCHASE_ANCHOR} className="block border-l-4 border-volt px-2 py-1.5" data-id="element-143" data-mp="q3xmxnjowg8x">
            <p className="text-[0.72rem] font-bold leading-tight text-white" data-id="element-144" data-mp="14wr1n6r50scj">
              {sale.name} just bought <span className="text-volt" data-id="element-145" data-mp="101twwc0w555g">GENERATOR DIAGNOSTIC PRO™</span>
            </p>
            <p className="mt-0.5 text-[0.62rem] font-semibold text-steel" data-id="element-146" data-mp="1dxpb44kchs2i">
              {sale.city}, {sale.country} • a few minutes ago
            </p>
          </a>
        </motion.aside> : null}
    </AnimatePresence>;
}